import { useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';
import { DOMAIN_MAP } from '../../../../utils/constants/domainMap';
import consoleLog from '../../../../utils/helpers/consoleLog';

const useQuizSocket = () => {
  const [gameSocket, setGameSocket] = useState(null);
  const [socketConnectedUsers, setSocketConnectedUsers] = useState([]);

  const [receivedAnswer, setReceivedAnswer] = useState([]);
  const [socketAnswerEvents, setSocketAnswerEvents] = useState([]);

  const [socketDisconnectedUsers, setSocketDisconnectedUsers] = useState([]);
  const [gameGuid, setGameGuid] = useState('');
  const [checkedStatusGame, setCheckedStatusGame] = useState(false);
  // const [quizGuid, setQuizGuid] = useState('');

  const domainMap = DOMAIN_MAP;

  let server = 'https://blueberry.tangerine-dev1.oneclicklabs.es';
  const ROOM = 'personal-notification';

  if (window.location.hostname !== 'localhost') {
    server = domainMap[window.location.host];
  }

  // let socket;
  const socket = useRef(null);

  const connectSocket = () => {
    const token = localStorage.getItem('bb_user_token') || '';

    socket.current = io(server, {
      path: '/api/socket.io',
      transports: ['websocket'],
      query: { token }
    });

    setGameSocket(socket);

    consoleLog('>>> Connected to Socket: socket', socket);

    socket.current.on(ROOM, (message) => {
      consoleLog('TEACHER SOCKET ON - ', message);
      if (message.event === 'start') {
        setGameGuid(message?.gameGuid);
        joinGame(message?.gameGuid);
      }
    });

    socket.current.on('quiz:user:connected', function (users) {
      consoleLog('SOCKET >> quiz:user:connected users: ', users);
      setSocketConnectedUsers(users);
    });

    socket.current.on('quiz:user:disconnected', function (users) {
      consoleLog('SOCKET >> quiz:user:disconnected users: ', users);
      setSocketDisconnectedUsers(users);
    });

    socket.current.on('sendAnswer', function (event) {
      consoleLog('SOCKET >> quiz:game:sendAnswer: ', event);
      setReceivedAnswer(event);
    });

    socket.current.on('statusGame', function (event) {
      consoleLog('SOCKET >> quiz:game:statusJoin: ', event);
      setCheckedStatusGame(true);
    });
  };

  const disconnectSocket = () => {
    if (socket.current) socket.current.disconnect();
  };

  const joinGame = (gameGuid) => {
    socket.current.emit(
      'quiz:game:join',
      { game_guid: gameGuid },
      function (response) {
        consoleLog('SOCKET >> quiz:game:join callback!', response);
      }
    );
  };

  const closeGame = (gameGuid) => {
    if (socket?.current) {
      socket.current.emit(
        'quiz:game:finish',
        { game_guid: gameGuid },
        function (response) {
          consoleLog('SOCKET >> quiz:game:finish callback!', response);
        }
      );
    }
    disconnectSocket();
  };

  const sendShowQuestion = (
    quizGuid,
    gameGuid,
    currentQuestion,
    secondsToAnswer,
    syncTimestamp
  ) => {
    if (socket.current)
      socket.current.emit(
        'quiz:game:event',
        {
          event: 'showQuestion',
          game_guid: gameGuid,
          quiz_guid: quizGuid,
          numberQuestion: currentQuestion,
          secondsToAnswer: secondsToAnswer,
          syncTimestamp: syncTimestamp
        },
        function (response) {
          consoleLog('SOCKET >> quiz:game:showQuestion callback!', response);
        }
      );
  };

  const sendShowSolution = () => {
    consoleLog('sendShowSolution payload', {
      event: 'showSolution',

      game_guid: gameGuid,
      // quiz_guid: quizGuid,
      showSolution: true
    });

    if (socket.current)
      socket.current.emit(
        'quiz:game:event',
        {
          event: 'showSolution',
          game_guid: gameGuid,
          // quiz_guid: quizGuid,
          showSolution: true
        },
        function (response) {
          consoleLog('SOCKET >> quiz:game:showSolution callback!', response);
        }
      );
  };

  const sendShowRanking = () => {
    consoleLog('sendShowRanking payload', {
      event: 'showRanking',
      game_guid: gameGuid,
      // quiz_guid: quizGuid,
      showRanking: true
    });

    if (socket.current)
      socket.current.emit(
        'quiz:game:event',
        {
          event: 'showRanking',
          game_guid: gameGuid,
          // quizGuid: quizGuid,
          showRanking: true
        },
        function (response) {
          consoleLog('SOCKET >> quiz:game:showRanking callback!', response);
        }
      );
  };

  const sendEndPractice = (playerList) => {
    consoleLog('sendEndPractice payload', {
      game_guid: gameGuid,
      playerList: playerList,
      showPodium: true
    });

    if (socket.current)
      socket.current.emit(
        'quiz:game:event',
        {
          event: 'endPractice',
          game_guid: gameGuid,
          playerList: playerList,
          showPodium: true
        },
        function (response) {
          consoleLog('SOCKET >> quiz:game:endPractice callback!', response);
        }
      );
  };

  const sendStatusGame = (payload) => {
    consoleLog('sendEndPractice payload', {
      game_guid: gameGuid,
      status: payload.status,
      numberQuestion: payload.numberQuestion,
      timer: payload.timer,
      playerList: payload.playerList
    });

    if (socket.current)
      socket.current.emit(
        'quiz:game:event',
        {
          event: 'responseStatusGame',
          game_guid: gameGuid,
          status: payload.status,
          numberQuestion: payload.numberQuestion,
          timer: payload.timer,
          playerList: payload.playerList
        },
        function (response) {
          consoleLog(
            'SOCKET >> quiz:game:responseStatusGame callback!',
            response
          );
        }
      );
  };

  const resetAnswerEvents = () => {
    setSocketAnswerEvents([]);
  };

  useEffect(() => {
    let _socketAnswerEvents = [...socketAnswerEvents, receivedAnswer];
    setSocketAnswerEvents(_socketAnswerEvents);

    consoleLog('NEW ANSWER:', receivedAnswer);
    consoleLog('_socketAnswerEvents', _socketAnswerEvents);
    consoleLog('_socketAnswerEvents.length', _socketAnswerEvents.length);
  }, [receivedAnswer]);

  return {
    socket,
    connectSocket,
    disconnectSocket,

    socketConnectedUsers,
    socketDisconnectedUsers,

    socketAnswerEvents,
    resetAnswerEvents,

    gameGuid,
    checkedStatusGame,
    sendShowQuestion,
    sendShowSolution,
    sendShowRanking,
    sendEndPractice,
    sendStatusGame,
    setCheckedStatusGame,

    closeGame
  };
};

export default useQuizSocket;
